import { render, staticRenderFns } from "./TestShell.vue?vue&type=template&id=20ca7a7b&"
import script from "./TestShell.vue?vue&type=script&lang=js&"
export * from "./TestShell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports